import { httpClient, postProcessDelete } from "@genai/http-client";
import { OrganizationId } from "../model";

export function deleteOrganization(organizationId: OrganizationId) {
  return  httpClient(`/organizations/${organizationId}`, {
    method: "DELETE",
  }).then(postProcessDelete);
}
